import React, { useEffect, useState } from 'react'
import { Chart } from 'primereact/chart'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Loader from '../../../Base/Components/Loader/Loader';
import Card from '../../../Base/Components/Card/Card'
import DevExpress from '../../../Base/Components/Tables/DevExpress/DevExpress';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';

import { colorCotton } from '../../../utils/KPIs/productionUtils';
import { ResumenVentasSemanales } from '../../../API/Ventas/ResumenVentasRequest';

const ResumenVentasSemanal = ({ date, kpiGerencia, getDatos }) => {


    const optionsChart = {
        responsive: true,
        interaction: {
        },
        plugins: {
            title: {
                display: true,
                text: 'Ventas por semana ($)',
                padding: 30
            },
            datalabels: {
                align: 'start',
                anchor: 'start',
            },
            legend: {
                position: 'bottom',
            },
        },
    }

    const [loading, setLoading] = useState(false);
    const [chart, setChart] = useState({
        data: {},
    });
    const [table, setTable] = useState({
        Data: [],
        Columns: [
            {
                // CuentaSemana
                field: 'CuentaSemana',
                header: '#',
                className: 'colum-width-Xsmall',
                body: (rowData) => rowData.CuentaSemana,
                align: 'right',
                Sumary: 'count'
            },
            {
                // Semana
                field: 'Semana',
                header: 'Semana',
                className: 'colum-width-medium',
                body: (rowData) => rowData.Semana,
                align: 'center',
            },
            {
                // MesD
                field: 'MesD',
                header: 'Mes',
                className: 'colum-width-medium',
                body: (rowData) => rowData.MesD,
            },
            {
                // Año
                field: 'Año',
                header: 'Año',
                className: 'colum-width-small',
                body: (rowData) => rowData.Año,

            },

            {
                // AmountT
                field: 'AmountT',
                header: 'Real ($)',
                flex:1,
                minWidth:300,
                // className: 'colum-width-',
                body: (rowData) => rowData.AmountT,
                Format: 'Currency',
                Sumary: 'sum'
            },
        ],
        filter: false,
        key: 'SemanaD',
        className: 'mt-2',
        scrollHeight: "75vh",
    })

    const getVentasWeek = async () => {
        setLoading(true);
        const tempo = await ResumenVentasSemanales({ year: date.getFullYear(), Mes: date.getMonth() + 1 });

        const data = tempo.map((item) => item.AmountT);

        const config = {
            type: 'bar',
            datalabels: {
                align: 'end',
                anchor: 'end',
                borderRadius: 4,
                marginButtom: 10,
                padding: 6,
                offset: 5,
                font: {
                    weight: 'light',

                },
                formatter: (value, context) => {
                    return '$ ' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },

            },
            barPercentage: 0.4,
        }

        setChart({
            data: {
                labels: ['Week-1', 'Week-2', 'Week-3', 'Week-4', 'Week-5'],
                datasets: [
                    {
                        ...config,
                        label: 'Semana',
                        backgroundColor: colorCotton,
                        borderColor: colorCotton,
                        data: data,
                    },
                ],
            }
        });
        setTable({
            ...table,
            Data: tempo,
            scrollHeight: (tempo.length * 33.02) + 26 + 32 + 'px',
        });


        setLoading(false);
    }


    useEffect(() => {
        getVentasWeek();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getVentasWeek();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date])

    useEffect(() => {
        if (getDatos) {
            getVentasWeek()
        }
    }, [getDatos])

    return (
        <div id='resumenVentasSemanal' style={{ height: '100vh' }}>
            <Loader loading={loading} querySelector={'#resumenVentasSemanal'} />
            <Card
                titulo={<h3>Semanal</h3>}
                contenido={
                    <div className='p-3' style={kpiGerencia ? {display: 'flex', gap: 30, alignItems: 'center', justifyContent: 'center'} : {}}>
                        <div style={kpiGerencia? {width: '50%'}: { width: '80%', margin: 'auto' }} >
                            <Chart data={chart.data} options={optionsChart} plugins={[ChartDataLabels]} />
                        </div>
                        <div style={kpiGerencia ? {width: '40%'} : { height: '40vh' }}>
                            <AgGrid  table={table}/>
                            {/* <DevExpress table={table} /> */}
                        </div>
                    </div>
                }
            />
        </div>
    )
}

export default ResumenVentasSemanal